import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import MonPagination from '../../components/Pagination/MonPagination';
import { setBuyStockPagination } from '../../redux/Actions/BuyStockAction';

function BuyStockPagination() {
    const dispatch = useDispatch();
    const { pagination } = useSelector((state) => state.BuyStockReducer);

    console.log('BuyStockReducer pagination:', pagination);

    // Extract pagination data from reducer
    const { page, limit, total, totalPages } = pagination;

    // Handle page change
    const handlePageChange = (newPage) => {
        dispatch(setBuyStockPagination({
            ...pagination,
            page: newPage
        }));
    };

    // Handle limit change
    const handleLimitChange = (newLimit) => {
        dispatch(setBuyStockPagination({
            ...pagination,
            limit: newLimit,
            page: 1 // Reset to first page when changing limit
        }));
    };

    // Limit options
    const limitOptions = [10, 20, 50, 100];

    return (
        <div className="flex justify-between items-center py-5 gap-4 w-full">
            <div className="flex items-center gap-2">
                <span className="text-sm text-gray-600">Show:</span>
                <div className="relative">
                    <select
                        value={limit}
                        onChange={(e) => handleLimitChange(parseInt(e.target.value))}
                        className="border border-gray-300 rounded px-3 py-1 pr-8 text-sm focus:outline-none focus:ring-2 focus:ring-black appearance-none bg-white cursor-pointer"
                    >
                        {limitOptions.map((option) => (
                            <option key={option} value={option}>
                                {option}
                            </option>
                        ))}
                    </select>
                </div>
            </div>

            <MonPagination
                total={total}
                outline={true}
                defaultCurrent={1}
                current={page}
                onChange={handlePageChange}
                pageSize={limit}
            />
        </div>
    );
}

export default BuyStockPagination;
